export const checkMarkIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16"
     fill="none" role="img" class="checkmarkIcon">
  <path
    d="M21.152 1.69807L7.42108 15.4426L0.266602 8.27487L1.42262 7.11879L7.42108 13.1047L19.996 0.541992L21.152 1.69807Z"
    fill="var(--zbp-svg-primary-color, black)"
  />
</svg>
`;
